import { gql } from "@/__generated__/gql";

export const REMOVE_OFFICIAL_FROM_ORGANIZATION_MUTATION = gql(`
  mutation RemoveOfficialFromOrganization(
    $userId: ID!
    $organizationId: ID!
  ) {
    removeOfficialFromOrganizationMutation(input: {
      userId: $userId
      organizationId: $organizationId
    }) {
      errors {
        title
        message
      }
    }
  }
`);
